import { useEffect, useState } from 'react';
import { type HealthResponse } from '@kratispot/shared';
import { fetchHealth } from '@/lib/api';

export type HealthState =
  { phase: 'checking' } | { phase: 'reachable'; report: HealthResponse } | { phase: 'offline' };

export function useHealth(): HealthState {
  const [state, setState] = useState<HealthState>({ phase: 'checking' });

  useEffect(() => {
    const controller = new AbortController();
    fetchHealth(controller.signal)
      .then((report) => setState({ phase: 'reachable', report }))
      .catch(() => {
        if (!controller.signal.aborted) setState({ phase: 'offline' });
      });
    return () => controller.abort();
  }, []);

  return state;
}
